<audio controls>
    <source [src]="src">
</audio>